import {userSelfQueryOptions} from '@blesk-frontend/api';
import {useQuery} from '@tanstack/react-query';
import {bleskAuthRedirectStore, bleskAuthStore} from './libs';

/**
 *
 */
export const useBleskAuth = () => {
  const {token, teamId, staffId, isAdmin, updateToken, logout} = bleskAuthStore();
  const {redirectUrl, updateRedirectUrl} = bleskAuthRedirectStore();
  const query = useQuery(userSelfQueryOptions());
  return {
    query,
    token,
    teamId,
    staffId,
    isAdmin,
    updateToken,
    logout,
    redirectUrl,
    updateRedirectUrl,
  };
};
